import IconActions from '../../../../shared/components/IconActions';
import React from 'react';
import PrimaryActionButton from '../../../../shared/components/patterns/PrimaryActionButton';
import { getStaffUserInitials } from '@/modules/settings/utils';

export default function ProfileSettingsForm({
  profile,
  isEditing,
  isLoading = false,
  isSaving = false,
  profileMissing = false,
  statusMessage = '',
  onFieldChange,
  onEdit,
  onSave,
  onCancel,
}) {
  return (
    <section className="settings-card">
      <header className="settings-card__header">
        <h2 className="settings-card__title">Profilo personale</h2>
        <p className="settings-card__description">Account base e profilo operativo staff collegato</p>
      </header>
      <div className="settings-card__body">
        {isLoading ? <p className="settings-muted">Caricamento profilo...</p> : null}
        {profileMissing ? (
          <div role="alert" className="settings-alert settings-alert--warning wt-inline-error">Completa il profilo operativo staff.</div>
        ) : null}
        {statusMessage ? <div className="settings-alert">{statusMessage}</div> : null}

        <div className="settings-profile-summary">
          <div className="settings-profile-summary__avatar">{getStaffUserInitials(profile.fullName)}</div>
          <div>
            <p className="settings-profile-summary__name">{profile.fullName || 'Profilo senza nome'}</p>
            <p className="settings-profile-summary__role">
              {profile.professionalTitle || 'Ruolo operativo non impostato'}
            </p>
          </div>
        </div>

        <div className="settings-form-grid">
          <label className="settings-field" data-form-field="title" htmlFor="fullName">
            <span>Nome completo</span>
            <input
              id="fullName"
              className="settings-input"
              value={profile.fullName}
              onChange={(event) => onFieldChange('fullName', event.target.value)}
              disabled={!isEditing}
            />
          </label>
          <label className="settings-field" htmlFor="email">
            <span>Email</span>
            <input
              id="email"
              type="email"
              className="settings-input"
              value={profile.email}
              onChange={(event) => onFieldChange('email', event.target.value)}
              disabled={!isEditing}
            />
          </label>
          <label className="settings-field" htmlFor="phone">
            <span>Telefono</span>
            <input
              id="phone"
              type="tel"
              className="settings-input"
              value={profile.phone}
              onChange={(event) => onFieldChange('phone', event.target.value)}
              disabled={!isEditing}
            />
          </label>
          <label className="settings-field" htmlFor="professionalTitle">
            <span>Ruolo professionale</span>
            <input
              id="professionalTitle"
              className="settings-input"
              value={profile.professionalTitle}
              onChange={(event) => onFieldChange('professionalTitle', event.target.value)}
              disabled={!isEditing}
            />
          </label>
          <label className="settings-field" htmlFor="staffType">
            <span>Tipo personale</span>
            <input id="staffType" value="Interno" readOnly className="settings-input" />
          </label>
          <label className="settings-field" htmlFor="skills">
            <span>Competenze</span>
            <input
              id="skills"
              className="settings-input"
              value={profile.skills}
              onChange={(event) => onFieldChange('skills', event.target.value)}
              disabled={!isEditing}
            />
          </label>
        </div>

        <div className="settings-actions"><IconActions>
          {!isEditing ? (
            <PrimaryActionButton onClick={onEdit} disabled={isSaving} iconKey="actions.edit">
              Modifica profilo
            </PrimaryActionButton>
          ) : (
            <>
              <PrimaryActionButton onClick={onSave} disabled={isSaving} iconKey="actions.save">
                {isSaving ? 'Salvataggio...' : 'Salva modifiche'}
              </PrimaryActionButton>
              <button
                type="button"
                className="settings-secondary-button"
                onClick={onCancel}
                disabled={isSaving}
              >
                Annulla
              </button>
            </>
          )}
        </IconActions></div>
      </div>
    </section>
  );
}
